import {
  CommandBar,
  ICommandBarItemProps,
  Icon,
  IContextualMenuItem,
  mergeStyles,
} from "@fluentui/react";
import { cloneDeep } from "lodash";
import { isBrowser } from "react-device-detect";

import { history } from "../../App/history";
import { useAppSelector } from "../../App/store";
import { addIcon } from "../../utils/icons";

export default () => {
  const isAdmin = useAppSelector((state) => state.auth.userdata?.admin);
  const userRank = useAppSelector((state) => state.auth.userdata?.rank);
  const userId = useAppSelector((state) => state.auth.user?.uid);

  const isAvailable = (item: ICommandBarItemProps) => {
    if (isAdmin) return true;

    if (isBrowser === false && item.data?.isBrowserOnly) return false;
    if (
      item.data?.visibleTo &&
      !item.data.visibleTo.includes(userRank) &&
      !item.data.visibleTo.includes(userId)
    )
      return false;

    return true;
  };
  const deepFilter = (items: ICommandBarItemProps[]) => {
    return items
      .map((item) => {
        const subItems = item.subMenuProps?.items;

        if (subItems) {
          item.subMenuProps!.items = deepFilter(subItems);
        }

        return item;
      })
      .filter(
        (item) =>
          (!item.subMenuProps || item.subMenuProps.items.length > 0) && isAvailable(item)
      );
  };

  return <CommandBar items={deepFilter(cloneDeep(items))} className={commandBarStyles} />;
};

const commandBarStyles = mergeStyles({
  "& button": {
    marginLeft: "4px",
    ":focus": {
      outline: "1px dashed currentColor !important",
    },
  },
  "& button.is-expanded": {
    outline: "1px dashed currentColor !important",
  },
});
const onClick = (
  ev?:
    | React.MouseEvent<HTMLElement, MouseEvent>
    | React.KeyboardEvent<HTMLElement>
    | undefined,
  item?: IContextualMenuItem | undefined
) => {
  if (ev && item) {
    const path = item.key;

    if (!path.startsWith("/")) {
      window.open(path);
    } else {
      history.push(path);
    }
  }
};

const items: ICommandBarItemProps[] = [
  {
    key: "/forms",
    text: "Form",
    iconProps: { iconName: "FabricOpenFolderHorizontal" },
    subMenuProps: {
      items: [
        {
          onClick,
          key: "/forms/new",
          text: "Yeni Form",
          iconProps: addIcon,
          data: { visibleTo: ["retail"] },
        },
        {
          onClick,
          key: "/forms/list",
          text: "Son Formlar",
          iconProps: { iconName: "List" },
          data: { visibleTo: ["retail"] },
        },
        {
          onClick,
          key: "/forms/search",
          text: "Form Arama",
          iconProps: { iconName: "Search" },
          data: { visibleTo: ["retail"] },
        },
      ],
    },
  },
  {
    key: "/invoices",
    text: "Fatura",
    iconProps: { iconName: "Page" },
    subMenuProps: {
      items: [
        {
          onClick,
          key: "/invoices/new",
          text: "Yeni Fatura",
          iconProps: { iconName: "PageAdd" },
          data: { visibleTo: ["retail"], isBrowserOnly: true },
        },
        {
          onClick,
          key: "/invoices/list",
          text: "Son Faturalar",
          iconProps: { iconName: "PageList" },
          data: { visibleTo: ["retail"], isBrowserOnly: true },
        },
        {
          onClick,
          key: "/invoices/settings",
          text: "Fatura Ayarları",
          iconProps: { iconName: "Settings" },
          data: { visibleTo: ["retail"], isBrowserOnly: true },
        },
      ],
    },
  },
  {
    onClick,
    key: "/calendar",
    text: "Takvim",
    iconProps: { iconName: "Calendar" },
    data: { visibleTo: ["retail"], isBrowserOnly: true },
  },
  {
    onClick,
    key: "/delivery-paper",
    text: "Teslim Kağıdı",
    iconProps: { iconName: "DeliveryTruck" },
    data: { visibleTo: ["warehouse"], isBrowserOnly: true },
  },
  {
    onClick,
    key: "/admin/analytics",
    text: "Analitikler",
    iconProps: { iconName: "BarChartVertical" },
    data: { visibleTo: [], isBrowserOnly: true },
  },
  {
    onClick,
    key: "/emaar",
    text: "Emaar Ciro",
    iconProps: { iconName: "Script" },
    data: { visibleTo: ["8TtTy0l2kiRNjhXW5W7M5szqSEi2"], isBrowserOnly: true },
  },
  {
    onClick,
    key: "/inventory",
    text: "Stok",
    iconProps: { iconName: "ProductList" },
    data: { visibleTo: ["retail"], isBrowserOnly: true },
  },
  {
    onClick,
    key: "/idas-shortcut",
    text: "İdaş",
    iconProps: { iconName: "SiteScan" },
    data: { visibleTo: ["retail"], isBrowserOnly: true },
  }
];
